package com.neurobs.react

trait ControlWrapperFactory {
	def edit(initialValue: String): EditControlWrapper

	def select(initialSelection: Option[Int]): SelectWrapper

	def checkbox(initialValue: Boolean): CheckboxControlWrapper
}

object ControlWrapperFactoryTest extends ControlWrapperFactory {
	override def edit(initialValue: String): EditControlWrapper = new SingleValueControlWrapperTest[String](initialValue) with StringValueControlWrapper

	override def select(initialSelection: Option[Int]): SelectWrapper = SelectWrapperTest(initialSelection)

	override def checkbox(initialValue: Boolean): CheckboxControlWrapper = SingleValueControlWrapperTest[Boolean](initialValue)
}

object ControlWrapperFactoryReact extends ControlWrapperFactory {
	override def edit(initialValue: String): EditControlWrapper = new EditWrapperReact(initialValue) with StringValueControlWrapper

	override def select(initialSelection: Option[Int]): SelectWrapper = new SelectWrapperReact(initialSelection)

	override def checkbox(initialValue: Boolean): CheckboxControlWrapper = new CheckboxWrapperReact(initialValue)
}

object ControlWrapperFactoryControlled extends ControlWrapperFactory {
	override def edit(initialValue: String): EditControlWrapper = throw new Exception("ControlWrapperFactoryInternal.edit not implemented")

	override def select(initialSelection: Option[Int]): SelectWrapper = SelectWrapperControlled(initialSelection)

	override def checkbox(initialValue: Boolean): CheckboxControlWrapper = throw new Exception("ControlWrapperFactoryInternal.checkbox not implemented")
}